import { render, staticRenderFns } from "./VechileBodyTypeTable.vue?vue&type=template&id=184577a8&"
import script from "./VechileBodyTypeTable.vue?vue&type=script&lang=js&"
export * from "./VechileBodyTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports